import { IBaseModel, BaseModel } from '../base.model';

export interface ITicketChannelParticipant extends IBaseModel {
  entity?: any;
  fk_actor_entity?: number
}
export class TicketChannelParticipant extends BaseModel implements ITicketChannelParticipant {
  /**
   *
   */
  constructor(opt?: ITicketChannelParticipant) {
    super(opt);
  }
}


// WEBPACK FOOTER //
// ./src/models/ticket/ticket-channel-participant.viewmodel.ts